import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface Campaign {
  id: number
  uuid: string
  name: string
  created_at: string
  updated_at: string
  user_id: number
  status: string
  email_count: number
  sent_count: number
  open_count: number
  click_count: number
  reply_count: number
}

interface CampaignState {
  campaigns: Campaign[]
  currentCampaign: Campaign | null
  isLoading: boolean
  error: string | null
}

const initialState: CampaignState = {
  campaigns: [],
  currentCampaign: null,
  isLoading: false,
  error: null,
}

const campaignSlice = createSlice({
  name: 'campaigns',
  initialState,
  reducers: {
    setCampaigns: (state, action: PayloadAction<Campaign[]>) => {
      state.campaigns = action.payload
    },
    addCampaign: (state, action: PayloadAction<Campaign>) => {
      state.campaigns.push(action.payload)
    },
    updateCampaign: (state, action: PayloadAction<Campaign>) => {
      const index = state.campaigns.findIndex(c => c.id === action.payload.id)
      if (index !== -1) {
        state.campaigns[index] = action.payload
      }
    },
    deleteCampaign: (state, action: PayloadAction<number>) => {
      state.campaigns = state.campaigns.filter(c => c.id !== action.payload)
    },
    setCurrentCampaign: (state, action: PayloadAction<Campaign | null>) => {
      state.currentCampaign = action.payload
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload
    },
  },
})

export const {
  setCampaigns,
  addCampaign,
  updateCampaign,
  deleteCampaign,
  setCurrentCampaign,
  setLoading,
  setError,
} = campaignSlice.actions

export default campaignSlice.reducer 